module.exports = __webpack_public_path__ + "img/logo-min.5b316d06.png";